export function LanguageSelectionButton(props) {
    return (
        <div
            className={`flex items-center cursor-pointer text-pine text-base font-bold select-none px-12 py-6 w-auto hover:bg-pine hover:text-white ${
                props.className ? props.className : ""
            }`}
            onClick={props.onClick}
        >
            {props.content}
        </div>
    );
}
